export default {"src":"/_next/static/media/GlossaryNoDataIcon.847ecb40.svg","height":64,"width":75,"blurWidth":0,"blurHeight":0};